import ConnectWallet from '../pages/connect-wallet'
import { Wallet } from 'lucide-react'

export default {
	icon: Wallet,
	name: 'Connect Wallet',
	component: ConnectWallet,
	featured: true,
	filter: ({ loggedIn }: any) => {
		return !loggedIn
	}
}
